import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { TQuizQuestion } from '@onesource/services';

import { AnswerCheckmark } from './answer-checkmark';

interface TrueFalseQuestionProps {
  question: TQuizQuestion;
  selectedOptionIds: string[];
  onSelect: (optionIds: string[]) => void;
  disabled?: boolean;
}

/**
 * True/False Question Component
 * Renders option cards matching the Figma design
 */
export const TrueFalseQuestion = ({
  question,
  selectedOptionIds,
  onSelect,
  disabled = false,
}: TrueFalseQuestionProps) => {
  const sortedOptions = [...question.options].sort((a, b) => a.position - b.position);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {sortedOptions.map((option, index) => {
        const isSelected = selectedOptionIds.includes(option.id);
        const optionLetter = String.fromCodePoint(65 + index); // A, B

        return (
          <Box
            key={option.id}
            onClick={() => !disabled && onSelect([option.id])}
            sx={{
              p: 2,
              bgcolor: 'white',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5,
              cursor: disabled ? 'default' : 'pointer',
              transition: 'all 0.2s',
              border: '2px solid',
              borderColor: isSelected ? '#ff4d6d' : 'transparent',
              '&:hover': disabled
                ? {}
                : {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
                  },
            }}
          >
            <AnswerCheckmark isSelected={isSelected} />

            {/* Option letter + text — smaller than the question, so the question leads. */}
            <Typography sx={{ fontSize: '0.9rem', lineHeight: 1.5 }}>
              <Box component="span" sx={{ color: '#ff4d6d', fontWeight: 'bold' }}>
                {optionLetter})
              </Box>{' '}
              {option.optionText}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
